<template>
  <div id="HeaderTopBar" class="header-bar header-top-bar-component htbc">
    <div v-if="ShowIEWarning">
      <b-alert class="ie-warning" show variant="danger">
        <p>You are currently browsing using Internet Explorer, which is no longer a supported browser by Microsoft, and therefore is no longer supported by this application. Current functionality will not be guaranteed in this unsupported state.</p>
        <p>Please upgrade your browser immediately to ensure the best experience. Suggested replacements are  
          <a href="https://www.google.com/chrome/">Google Chrome</a> or <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a>.
        </p>
      </b-alert>
    </div>    
    <div class="global-tools container">
      <div class="row justify-content-between no-gutters">
        <div class="col-4">
          <router-link :to="{name: 'Home'}" class="htbc__logo-wrapper">
            <img :src="LogoImage" class="htbc__logo">  
          </router-link>
        </div>
        <div v-if="shouldShowNavIcons === true" class="col-auto btn-group">
          <ul class="nav nav-icons htbc__nav-icons">
            <!-- Dealer Code -->
            <li class="htbc__dealer-code">
              <AvailableDealerCodeSelector
                :show-all-branches-option="false"
                :show-label="false"
                class="htbc__dealer-code-selector"
                @selectDealerCode="SetUserDealerCode"
              />
            </li>
            <!-- Account Details -->
            <li @mouseover="handleDropdownEvents('account', true)" @mouseleave="handleDropdownEvents('account', false)">
              <div class="dropdown menu-button">
                <a
                  id="accountMenuLink"
                  href="#"
                  class="dropdown-toggle htbc__account-selector"
                  data-display="static"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <router-link to="/account/accountdetails"><span><i class="icon nav-account" /></span></router-link>
                </a>
                <div id="accountDropDown" class="dropdown-menu accountMenu" aria-labelledby="accountMenuLink">
                  <h6 id="welcomeHeader" class="dropdown-header">
                    Welcome, {{ user.FullName }}
                  </h6>
                  <ul>
                    <li>
                      <router-link class="dropdown-item" :to="{name: 'AccountDetails'}">
                        {{ getContentItem('accountDetailsMenu') }}
                      </router-link>
                    </li>
                    <li>
                      <router-link class="dropdown-item" :to="{name: 'UserSettings'}">
                        {{ getContentItem('userSettings') }}
                      </router-link>
                    </li>
                    <li>
                      <a :href="urlMyPrivacy" target="_blank">
                        {{ getContentItem('My Privacy') }}
                      </a>
                    </li>
                    <li>
                      <router-link class="dropdown-item" :to="{name: 'AddressBookList'}">
                        {{ getContentItem('addressBookMenu') }}
                      </router-link>
                    </li>
                    <li>
                      <router-link class="dropdown-item" :to="{name: 'WarehouseShippingOptions'}">
                        {{ getContentItem('warehouseShippingOptionsMenu') }}
                      </router-link>
                    </li>
                    <li><a class="dropdown-item" href="#" @click="Logout">Logout</a></li>
                    <li id="accountsMenuPrice">
                      <h4 id="priceSwitchLabel" class="dropdown-item pull-left">
                        Price:
                      </h4>
                      <div class="btn-group">
                        <button
                          id="globalPriceShowButton"
                          class="btn btn-mini"
                          :disabled="isPriceVisible"
                          @click="SetPriceVisibility(true)"
                        >
                          Show
                        </button>
                        <button
                          id="globalPriceHideButton"
                          class="btn btn-mini"
                          :disabled="!isPriceVisible"
                          @click="SetPriceVisibility(false)"
                        >
                          Hide
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <!-- Part list -->
            <li
              class="dropdown dropdown-hover"
              @mouseover="ShowPartLists"
              @mouseleave="handleDropdownEvents('partList',false)"
            >
              <div>
                <a id="partListMenuLink" href="#" data-display="static"><span><i
                  class="icon nav-parts-lists"
                  @click="$router.push({name: 'QuickOrders', query: {activeView: 'partLists'}})"
                /></span></a>
                <div id="partListDropDown" class="dropdown-menu partListMenu" aria-labelledby="partListMenuLink">
                  <ul class="headerPartList">
                    <li>
                      <a id="btnCreateNewPartListGlobal" data-toggle="modal" data-target="#newPartListModal">Create
                        New... <i class="icon-plus" /></a>
                    </li>
                    <li v-for="(partListItem,partListKey) in partsLists" :key="partListKey">
                      <router-link :to="{name: 'QuickOrders', query: {partListId: partListItem.Id}}">
                        {{ partListItem.PartListName }}
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{name: 'QuickOrders', query: {activeView: 'partLists'}}">
                        See All
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <!-- Documents Library -->
            <li v-if="documentsLibraryEnabled" class="dropdown dropdown-hover">
              <router-link :to="{name: 'ResourceLibrary'}">
                <img :src="DocLibIcon">
              </router-link>
            </li>
            <li v-if="canPlaceOrders">
              <ShoppingCartCount />
            </li>
            <!-- LTS Portal Link -->
            <li v-if="IsMcfe" class="htbc__lts-portal-link">
              <a :href="ltsPortalLink" target="_blank" rel="noopener" class="htbc__lts-portal-link-anchor">{{ ltsPortalLinkText }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from "jquery"
  import { mapGetters } from "vuex"
  import { controlsHelper } from "@/components/mixins/commonControlsHelper"
  import { themeHelper } from "@/components/mixins/themeHelper"
  import { sessionHelper } from "@/components/mixins/sessionHelper"
  import ShoppingCartCount from "./ShoppingCartCount"
  import { AvailableDealerCodeSelector } from "@/components/Dropdowns";
  import { FeatureFlagService } from "@/services/FeatureFlagService";
  import { constants } from "@/const";

  export default {
    components: {
      ShoppingCartCount,
      AvailableDealerCodeSelector
    },
    mixins: [controlsHelper, themeHelper, sessionHelper],
    props: {
      theme: {
        type: String,
        default: "Default"
      },
      shouldShowNavIcons: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
    urlMyPrivacy: "",
    documentsLibraryEnabled: true,
    ltsPortalLink: '',
    ltsPortalLinkText: 'LTS Portal'
    }),
    computed: {
      ...mapGetters([
        "user",
        "hasPermission",
        "getContentItem",
        "partsLists",
        "isPriceVisible",
        "availableDealerCodes",
        "tenantDetails",
        "canPlaceOrders",
         "IsMcfe"
      ]),
      LogoImage: function () {
        var image = this.getImage("logo")
        return image
      },
      DocLibIcon: function () {
            const icon = this.getImage("docLibIcon")
            return icon
      },
      ShowIEWarning: function() {
        return IsIE()
      }
    },
    created() {
      this.urlMyPrivacy = window.appGlobals.GLOBAL_LOGIN_MY_PRIVACY;
      this.documentsLibraryEnabled = FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.DOCUMENTS_LIBRARY_ENABLED)
      this.ltsPortalLink = window.appGlobals.GLOBAL_LTS_PORTAL_LINK
    },
    methods: {
      SetUserDealerCode: function (selectedAvailableDealerCode) {
        if (selectedAvailableDealerCode.PrimaryDealerCode !== undefined) {
          var params = {};
          params.dealerCode = selectedAvailableDealerCode.PrimaryDealerCode;
          params.isDn6 = window.appGlobals.IS_DN6;
          params.sessionVarString = this.getSessionVarString(this.user.UserId);
          params.refreshAfterProcessing = true;
          this.$store.dispatch("UPDATE_DEALER_CODE", params);
        }
        $("#displayWithSubDealers span.selected-tag").addClass("dealerCodeDropdownText")
      },
      Logout: function () {
        this.$store.dispatch("LOGOUT")
      },
      ShowPartLists () {
        if (this.partsLists.length == 0) {
          this.$store.dispatch("LOAD_PARTS_LISTS")
        }
        this.handleDropdownEvents("partList", true)
      },
      SetPriceVisibility: function (isPriceVisible) {
        this.$store.dispatch("SET_PRICE_VISIBILITY", isPriceVisible).then(visibilityResponse => {
          $("#globalPriceHideButton").removeClass("active")
          $("#globalPriceShowButton").removeClass("active")
        })
      }
    },
  }
</script>

<style lang="scss">
.htbc__logo-wrapper{
  position: relative;
  display: block;
  height: 90%;
  margin:10px;
}

.htbc__logo{
  width: 40%;
}
.htbc__dealer-code-selector{
  width: 450px;
  padding: 0px;
  margin: 0px;

  .dropdown-menu li {
    margin: 0px;
    padding-left: 0px;
    display: flex;
  }
}

@media (max-width: $screen-sm-max){
  .htbc__dealer-code-selector{
      width: 100%;
  }

.htbc__dealer-code{
      width: 100%;
  }

  .htbc__logo{
    width: 120%;
  }
}

.htbc__lts-portal-link {
  padding: 8px 20px;
}


#HeaderTopBar .nav-icons .htbc__lts-portal-link-anchor {
  color: white !important;
  text-align: center;
  line-height: 14px;
  padding: 0;
  font-size: 12px;
  display: inline-block;
  text-decoration: underline;
}

#HeaderTopBar .nav-icons .htbc__lts-portal-link-anchor:hover {
  color: $light-blue !important;
  text-decoration: underline;
}

</style>